import React, { ReactElement, useContext } from "react";
import { ChipProps } from "@mui/material";
import { StyledEyeBrow } from "./eyeBrow.style";
import { ThemeContext } from "styled-components";
import DefaultUptimeTheme from 'component/theme/defaultTheme';

export interface IStyledEyeBrowProps extends ChipProps{
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  label: string;
  fontSizeContent?: any;
};

const EyeBrow: React.FC<IStyledEyeBrowProps> = (props):JSX.Element => {
const {
  startIcon,
  endIcon,
  label,
  fontSizeContent,
  ...chipProps
} = props;

 const theme = useContext(ThemeContext) as typeof DefaultUptimeTheme;

return (
      <StyledEyeBrow
        avatar={startIcon}
        deleteIcon={endIcon}
        onDelete={endIcon ? () => {} : undefined}
        label={label}
        paddingTop={theme.uptimeDynamicAlignCenter?.marketplace?.eyebrow?.paddingTop ?? theme.uptimeSpace[0]}
        {...chipProps}
      />
  );
};

EyeBrow.defaultProps = {
  label: '',
  variant: 'outlined',
  color: 'primary',
  sx: {},
  fontSizeContent: 12
};

export default EyeBrow;